// extracted by mini-css-extract-plugin
export var heading = "ParagraphVideo-module--heading--21980";
export var paragraphvideoinner = "ParagraphVideo-module--paragraphvideoinner--06731";
export var paragraphvideoouter = "ParagraphVideo-module--paragraphvideoouter--49706";
export var videoheading = "ParagraphVideo-module--videoheading--75c0c";
export var videotext = "ParagraphVideo-module--videotext--34b64";